/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Broker_Status_LinkedInputs */

const cs_ebr_broker_status_linked = /** @type {(inputs: Ebr_Broker_Status_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojí se s existujícím`)
};

const en_ebr_broker_status_linked = /** @type {(inputs: Ebr_Broker_Status_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links to existing user`)
};

/**
* | output |
* | --- |
* | "Links to existing user" |
*
* @param {Ebr_Broker_Status_LinkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_broker_status_linked = /** @type {((inputs?: Ebr_Broker_Status_LinkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Broker_Status_LinkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_broker_status_linked(inputs)
	return cs_ebr_broker_status_linked(inputs)
});